export const DEFAULT_PROJECT_IMAGE =
    'https://d31ezp3r8jwmks.cloudfront.net/variants/VnKKpkmnzP15y7859k6FjtQu/d2e337a4f6900f8d0798c596eb0607a8e0c2fbddb6a7ab7afcd60009c119d4c7';
